import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
  const navigate = useNavigate();
  const [timer, setTimer] = useState(3);

  useEffect(() => {
    // Clear Cognito session
    try {
      const cognitoStorageKeys = Object.keys(localStorage).filter(k =>
        k.includes('CognitoIdentityServiceProvider')
      );
      cognitoStorageKeys.forEach(key => localStorage.removeItem(key));
    } catch {}
    localStorage.removeItem('isLoggedIn');
    // Countdown timer
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      navigate('/login', { replace: true });
    }
  }, [timer, navigate]);

  useEffect(() => {
    // Disable back navigation (trap user on logout page)
    const handlePopState = () => {
      window.history.go(1);
    };
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '10vh' }}>
      <h2>You have been logged out.</h2>
      <p>Redirecting to login in {timer}...</p>
    </div>
  );
};

export default Logout;
